var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "backdrop" }, [_c("RouterView")], 1),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("MFAValidation", {
          attrs: {
            configName: this.$store.state.Auth.mfaConfigName,
            nextRoute: this.$store.state.Auth.mfaLoginEndpoint,
            token: this.$store.state.Auth.mfaToken
          },
          on: { close: () => (_vm.submittingForm = false) }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }